/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Crosspostingconnect1Inputs */

const en_crosspostingconnect1 = /** @type {(inputs: Crosspostingconnect1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Connect`)
};

const de_crosspostingconnect1 = /** @type {(inputs: Crosspostingconnect1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verbinden`)
};

/**
* | output |
* | --- |
* | "Connect" |
*
* @param {Crosspostingconnect1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const crosspostingconnect1 = /** @type {((inputs?: Crosspostingconnect1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Crosspostingconnect1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_crosspostingconnect1(inputs)
	return de_crosspostingconnect1(inputs)
});
export { crosspostingconnect1 as "crosspostingConnect" }